import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
} from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { T } from '../../../../../../../Translations';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

function CancelModal({ isOpen, onClose }: Props) {
  const navigate = useNavigate();

  const handleDiscard = () => {
    // Use setTimeout to allow React to complete state updates and modal cleanup
    // before navigation, preventing orphaned portal elements from blocking UI
    setTimeout(() => navigate('/learning_collections'), 0);
  };

  return (
    <Modal open={isOpen} onClose={onClose} data-intercom-target="builder-v2-discard-modal">
      <ModalHeader className="w-full justify-between items-center">
        <Typography variant="subtitleLarge" fontWeight="semibold">
          <T kind="Discard this collection" />
        </Typography>
      </ModalHeader>
      <ModalBody>
        <Typography variant="bodyMedium">
          <T kind="If you leave now the collection will not be saved and cannot be restored later. Are you sure you want to continue?" />
        </Typography>
      </ModalBody>
      <ModalFooter className="flex-row justify-end">
        <Button
          variant="text"
          color="secondary"
          onClick={onClose}
          data-intercom-target="builder-v2-discard-modal-cancel-button"
        >
          <T kind="Cancel" />
        </Button>
        <Button
          color="error"
          onClick={handleDiscard}
          data-intercom-target="builder-v2-discard-modal-confirm-button"
        >
          <T kind="Discard Changes" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default observer(CancelModal);
